
import Vue from 'vue';
import Default from '@/components/Default.vue';
import { HTTP } from '@/utils/http-common';
export default Vue.extend({
  components: {
    Default,
  },
  data() {
    return {
      data: {
        headline: 'Mapa strony',
        sitemap: [
          {
            name: 'Strona Główna',
            url: '/',
            children: [
              {
                name: 'Aktualności',
                url: '/aktualnosci',
              },
            ],
          },
          {
            name: 'Krwiodawca',
            children: [
              {
                name: 'Pierwszorazowy',
                url: '/krwiodawca',
              },
              {
                name: 'Wielokrotny',
                url: '/krwiodawca-wielokrotny',
              },
              {
                name: 'Jak oddać krew?',
                url: '/droga-dawcy-krwi',
              },
              {
                name: 'Gdzie i kiedy oddać krew?',
                url: '/kalendarium',
              },
              {
                name: 'Przeciwwskazania',
                url: '/przeciwwskazania',
              },
              {
                name: 'Sytuacja epidemiologiczna',
                url: '/sytuacja-epidemiologiczna',
              },
              {
                name: 'Fakty i mity',
                url: '/fakty-mity',
              },
              {
                name: 'Jak zostać dawcą szpiku',
                url: '/osrodek-dawcow-szpiku',
              },
            ],
          },
          {
            name: 'Dla podmiotów leczniczych',
            children: [
              {
                name: 'Bank tkanek',
                url: '/bank-tkanek',
              },
              {
                name: 'Odczynniki serologiczne',
                url: '/odczynniki-serologiczne',
              },
              {
                name: 'Badania HLA',
                url: '/badania-hla',
              },
              {
                name: 'Kursy i szkolenia',
                url: '/kursy-szkolenia',
              },
              {
                name: 'Pliki do pobrania',
                url: '/pliki-do-pobrania',
              },
              {
                name: 'Zamówienia publiczne',
                url: '/zamowienia-publiczne',
              },
            ],
          },
          {
            name: 'O Nas',
            url: 'o-nas',
            children: [
              {
                name: 'Osiągnięcia',
                url: '/osiagniecia',
              },
            ],
          },
          {
            name: 'Dla pacjentów',
            children: [
              {
                name: 'Kobiety w ciąży',
                url: '/kobiety-w-ciazy',
              },
              {
                name: 'Chorzy na hemofilię',
                url: '/chorzy-na-hemofilie',
              },
            ],
          },
          {
            name: 'Kontakt',
            url: '/kontakt',
            children: [
              {
                name: 'Działy',
                url: '/kontakt#departments',
              },
              {
                name: 'Terenowe Oddziały',
                url: '/kontakt#branch_offices',
              },
              {
                name: 'Jak do nas dojechać?',
                url: '/kontakt#how-to-get',
              },
            ],
          },
          {
            name: 'Stopka',
            children: [
              {
                name: 'Praca i praktyki',
                url: '/praca-praktyki',
              },
            ],
          },
        ],
      },
    };
  },
});
